import React from "react"
import {FieldManagementPreviewProps} from "../../../../render/management-preview";


export default function FieldVoting_ManagementPreview(props: FieldManagementPreviewProps) {

    return (
        <div className="ui5-reactions">
            <div className="reaction-view my-reaction">
                <div className="reaction-emoji">👍</div>
                <div className="reaction-count">5</div>
            </div>
        </div>
    )

}